<template>
  <div class="filter-list">
    <div v-if="filters" class="level-left">
      <DropDown
        v-for="filter in filters"
        :key="filter.name"
        :filter="filter"
        :selectedFilters="getSelectedFilters(filter.name)"
        :showOnlyUniqueUsers="showOnlyUniqueUsers"
        :disabled="dropDownDisabled(filter.name)"
        @filterChange="filterChange"
      />
    </div>
    <div v-if="showUniqueUsersCheckBox">
      <BCheckbox v-model="showOnlyUniqueUsers" class="unique-checkbox" :disabled="uniqueUsersDisabled">
        {{ "dropdown.unique" | t }}
      </BCheckbox>
      <VsTooltip label="analyticsDefinitions.virtusizeUsers.definition" />
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import DropDown from "./DropDown";
import { mapGetters, mapActions } from "vuex";
import getFilters from "@/misc/chartFilters";

export default {
  name: "ChartFilters",
  components: {
    DropDown,
  },
  props: {
    page: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      filters: [],
      showOnlyUniqueUsers: false,
    };
  },
  computed: {
    ...mapGetters({
      currentStore: "user/getCurrentStore",
      activeViewName: "performance/getActiveViewName",
      activeFilters: "filters/getAllActiveFilters",
    }),
    showUniqueUsersCheckBox() {
      // temporarily turn off show unique users checkbox until we figure out better way to query the data
      // return ['usage', 'performance'].includes(this.page)
      return false;
    },
    uniqueUsersDisabled() {
      return (
        this.activeFilters?.itemCategories?.length > 0 ||
        this.activeFilters?.countries?.length > 0 ||
        this.activeViewName === "saleShare"
      );
    },
  },
  watch: {
    showOnlyUniqueUsers(newValue) {
      this.setOnlyUniqueUsers(newValue);
    },
    currentStore() {
      this.filters = getFilters(this.page, this.currentStore);
    },
    uniqueUsersDisabled(disabled) {
      if (disabled) {
        this.showOnlyUniqueUsers = false;
      }
    },
  },
  created() {
    this.filterChange = _.debounce(this.updateGlobalFilters, 1000);
  },
  mounted() {
    this.filters = getFilters(this.page, this.currentStore);
  },
  methods: {
    ...mapActions("filters", ["updateGlobalFilters", "setOnlyUniqueUsers"]),
    getSelectedFilters(name) {
      const filters = this.activeFilters[name];

      if (!filters?.length) return [];
      if (name === "products") return filters[0].name;
      return filters.map((filter) => filter.name);
    },
    dropDownDisabled(name) {
      return ["itemCategories", "countries"].includes(name) && this.showOnlyUniqueUsers;
    },
  },
};
</script>

<style lang="scss">
// styles below this point are to overwrite buefy styles
.filter-list {
  z-index: 2000;

  .dropdown-content,
  .checkbox .check {
    border-radius: 0 !important;
  }

  .check {
    border-width: 1px !important;
  }

  .b-checkbox,
  .checkbox,
  .b-radio,
  .radio {
    width: 100%;
    margin-left: 0 !important;
    padding: 0.375rem 1rem;
  }

  .unique-checkbox {
    width: auto;
    padding: 0 0 1rem;
  }
}
</style>
